/* unplugin-vue-components disabled */import script from "./View.vue?vue&type=script&lang=ts&setup=true"
export * from "./View.vue?vue&type=script&lang=ts&setup=true"

import "./View.vue?vue&type=style&index=0&id=26c21dc5&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c21dc5"]])

export default __exports__